import axios from 'axios';

export function getFlagCompliance() {
    return axios({
        method: 'GET',
        url: '/api/v2/flag-compliance',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateFlagCompliance(complianceId, { avoid, riskFactor }) {
    return axios({
        method: 'PUT',
        url: `/api/v2/flag-compliance/${complianceId}`,
        data: {
            avoid,
            riskFactor,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/flagCompliance.js